import { graphql } from "~/gql";

export const FILTER_MATTERS = graphql(/* GraphQL */ `
  query FilterMatters($input: FilteredMattersInput!) {
    filteredMatters(input: $input) {
      count
      matters {
        __typename
        reference
        id
        isParent
        title
        createdAt
        client {
          id
          name
          externalReference
          type
        }
        organisationalUnit {
          __typename
          id
          name
          parent {
            id
            name
          }
        }
        updatedAt
        status
        createdAt
        createdBy {
          id
          userName
          displayName
        }
        externalMatterId
        externalReference
        currency {
          id
          code
        }
      }
    }
  }
`);
